import { render, staticRenderFns } from "./MetricCardInboxTeam.vue?vue&type=template&id=f3c8c202&scoped=true&"
import script from "./MetricCardInboxTeam.vue?vue&type=script&lang=js&"
export * from "./MetricCardInboxTeam.vue?vue&type=script&lang=js&"
import style0 from "./MetricCardInboxTeam.vue?vue&type=style&index=0&id=f3c8c202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c8c202",
  null
  
)

export default component.exports